var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.848 13.954-1.107 4.829c-.127.554.574.862.973.458l2.947-3.16 4.598 3.435c.844.48 1.438.227 1.665-.792l3.019-14.426c.268-1.272-.45-1.77-1.272-1.458L2.93 9.77c-1.211.48-1.193 1.168-.206 1.48l4.536 1.439 10.744-6.693c.496-.335.739-.181.368.154l-8.523 7.805Z",
    fill: "#666"
  })));
};
export default SvgSend;